import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';
import Season from './Season';
import { matterStart, matterExit } from 'lib/matter';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.color};
`;

const Wrapper = styled.div`
  width: 1440px;
  height: 1252px;
  position: relative;
  margin: 0 auto;

  ${media.w1440`
    width: 1200px;
    height: 1062px;
  `}
  ${media.w1200`
    width: 1024px;
    height: 1098px;
  `}
  ${media.tablet`
    width: 800px;
    height: 1118px;
  `}
  ${media.w800`
    width: 600px;
    height: 1118px;
  `}
  ${media.mobile`
    width: 375px;
    height: 1343px;
  `}
`;

class Lookbook extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  componentDidMount() {
    matterStart();
  }

  componentWillUnmount() {
    matterExit();
  }

  render() {
    const { color, data, UIActions } = this.props;

    return (
      <Container color={color}>
        <div className="test" />
        <Wrapper>
          <Season color={color} data={data} UIActions={UIActions} />
        </Wrapper>
      </Container>
    );
  }
}

export default Lookbook;



// WEBPACK FOOTER //
// ./src/components/Lookbook/index.js